import styled from 'styled-components';
import { lighten } from 'polished';
import { Flex, Box } from 'reflexbox/styled-components';
import { MessageCircle } from 'styled-icons/feather';
import Link from 'next/link';

import { colors } from '@/themes';
import Section from '@/components/section';
import TitleBase from '@/components/title';
import SubTitle from '@/components/sub-title';
import Paragraph from '@/components/paragraph';
import CardBase from '@/components/card';

const Title = styled(TitleBase)`
  color: ${props => props.theme.colors.brand.primary};
  margin-top: 0;
`;

const Card = styled(CardBase)`
  align-items: center;
  display: flex;

  svg {
    margin-right: 1em;
  }
`;

const Hero = () => {
  return (
    <Section backgroundColor={lighten(.35, colors.brand.primary)}>
      <Flex>
        <Box width={[1, 1, 1/2]}>
          <Title>The Bidali Blog</Title>
          <SubTitle>Stories from the future of commerce.</SubTitle>
          <Card>
            <MessageCircle color={colors.typography.subtle} size={48} />
            <Paragraph>Have a story you think we should share? <Link href="/contact"><a>Contact us</a></Link>.</Paragraph>
          </Card>
        </Box>
      </Flex>
    </Section>
  );
};

export default Hero;
